function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M164.4079,130.82104l.01672-.03192,.01691-.03186c2.74695-5.17297,6.93323-9.35919,12.10602-12.10596,4.20917-2.23517,8.94476-3.41663,13.6947-3.41663,8.35193,0,16.13055,3.53784,21.59253,9.53217l22.93066-16.0434c12.54968-8.7804,15.60535-26.07184,6.82495-38.62158l-20.99304-30.00513c-8.7804-12.54974-26.07184-15.60541-38.62158-6.82501L21.23456,145.73401c-12.54968,8.7804-15.60535,26.07184-6.82495,38.62158l20.99304,30.00513c8.7804,12.54974,23.02704,17.73572,35.57672,8.95532l70.93787-49.63153,22.49066-42.86346Z",
  fill: "#121111"
}), React.createElement("circle", {
  cx: 196.17556,
  cy: 76.86519,
  r: 7.31575,
  fill: "#8c8c8c"
}), React.createElement("path", {
  d: "M254.13212,234.71352l-50.95869-97.10881c-3.78865-7.13475-12.6438-9.8473-19.77855-6.05865-2.57904,1.36951-4.68915,3.47961-6.05865,6.05865l-50.95869,97.1189c-2.33989,4.48854-2.15625,9.87505,.4839,14.1938,2.67348,4.29431,7.37108,6.90794,12.4296,6.91551h101.92751c5.06221-.01373,9.76155-2.62991,12.44-6.92551,2.63184-4.32213,2.81146-9.70595,.47359-14.19389Zm-71.44301-59.5275c.01712-4.17563,3.416-7.54677,7.59163-7.52965,4.15533,.01703,7.51814,3.38428,7.52968,7.53964v30.24249c-.01462,4.17563-3.41148,7.5488-7.58711,7.53419-4.15498-.01456-7.51965-3.37921-7.53419-7.53419v-30.25249Zm7.56059,63.0155c-5.56752,0-10.0809-4.51338-10.0809-10.0809s4.51338-10.0809,10.0809-10.0809,10.0809,4.51338,10.0809,10.0809c-.00204,5.56668-4.51421,10.07886-10.08089,10.0809h-.00002Z",
  fill: "#ffc02c"
}), React.createElement("path", {
  d: "M164.4079,130.82104l.01672-.03192,.01691-.03186c2.74695-5.17297,6.93323-9.35919,12.10602-12.10596,2.31451-1.22906,4.79083-2.12689,7.33856-2.69751l-33.61938-48.32599-85.20947,59.61664,41.37628,59.47607,45.25842-31.66492,12.71594-24.23456Z",
  fill: "#606060"
}));

var SvgWebappIconBadInstallationDetectedLightTheme = function SvgWebappIconBadInstallationDetectedLightTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconBadInstallationDetectedLightTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-bad-installation-detected-light-theme.a9892fcc.svg";
export { ForwardRef as ReactComponent };